<template>
  <div id="midialog">
    <v-toolbar flat color="white">
      <v-toolbar-title>Tribunales</v-toolbar-title>
      <v-divider
        class="mx-4"
        inset
        vertical
      ></v-divider>
      <div class="flex-grow-1"></div>
      <v-dialog v-model="dialog" persistent>
        <v-form ref="form" v-model="valid">
          <template v-slot:activator="{ on }">
            <!-- se puso transaparent y text para np mostrarlo al hacer render la vista-->
            <v-btn color="transparent" text class="mb-2" v-on="on">Nuevo</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline"> Nuevo Tribunal</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      outlined
                      v-model="tribunal.nombre"
                      label="Nombre"
                      required
                      :rules="[v => !!v || 'Campo requerido']"
                      @input="v => { tribunal.nombre = v.toUpperCase() }"

                      ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-select
                      label="Tipo"
                      :items = "tipo_tibunal"
                      item-text="nombre"
                      item-value="id"
                      persistent-hint
                      v-model="tribunal.tipo"
                      outlined
                      required
                      :rules="[v => !!v || 'Campo requerido']"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-toolbar>

  </div>
</template>


<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      valid: true,
      tipo_tibunal: [{id:1, nombre:'Civil'}, {id:2, nombre:'Familiar'} ],
      tribunal: {
        nombre: "",
        tipo:"",
        activo: 1
      }
    };
  },
  mounted() {
    this.dialog = true;
  },
  computed: {
    ...mapGetters(["getAllTribunales"])
  },
  created() {
    this.$store.dispatch("GET_ALL_TRIBUNALES", { url: "tribunales" });
  },
  methods: {
    close() {
      this.dialog = false;
      return this.$router.push({ name: "Tribunales" });
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("SAVE_TRIBUNAL",  { url: "/tribunal", data: this.tribunal } ).then(res => {
          this.$swal({
            title: "Exito!!!",
            text: res.data.message,
            icon: 'success',
            confirmButtonText: "Aceptar"
          });
          this.$router.push({ name: "Tribunales" });
        })
        .catch(error => {
          this.$swal({
            title: "Error!!!",
            text: error.response.data.message,
            icon: 'warning',
            confirmButtonText: "Aceptar"
          })
        });
      }
    }
  }
};
</script>
